// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"457":"present-watch-scene","622":"device-scene"}[chunkId] || chunkId) + "." + {"413":"0a5c6d9a","453":"1c0f9164","457":"b335ca9b","622":"2057c027","646":"a03526cb","834":"ec20c394"}[chunkId] + ".chunk.js";
};